import { render, staticRenderFns } from "./ClipPlayerClipDetails.vue?vue&type=template&id=7b878820&scoped=true&"
import script from "./ClipPlayerClipDetails.vue?vue&type=script&lang=ts&"
export * from "./ClipPlayerClipDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ClipPlayerClipDetails.vue?vue&type=style&index=0&id=7b878820&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b878820",
  null
  
)

export default component.exports